/* eslint-disable multiline-ternary */
/* eslint-disable prettier/prettier */
/* eslint-disable @typescript-eslint/no-unused-vars */
import PusherJS from 'pusher-js'
import type * as PusherTypes from 'pusher-js'
import React, {
  useState,
  type ReactElement,
  useEffect,
  useRef,
  useMemo
} from 'react'
import {
  Input,
  InputGroup,
  InputLeftAddon,
  Box,
  Button,
  Heading,
  IconButton,
  Flex,
  FormLabel,
  FormHelperText,
  FormErrorMessage,
  FormControl,
  Grid,
  Select,
  Spinner,
  Text,
  Checkbox
} from '@chakra-ui/react'
import { ArrowUpIcon } from '@chakra-ui/icons'
import EmojiPicker, { EmojiStyle } from 'emoji-picker-react'
import Map, { Marker } from 'react-map-gl'
import { profanity } from '@2toad/profanity'
// import { Nostalgist, type Nostalgist as NostalgistType } from 'nostalgist'
// import CryptoJS, { MD5 } from 'crypto-js'
import PlayAlong from './Playalong'

import 'mapbox-gl/dist/mapbox-gl.css'

import { ErrorModal } from '../../components/Modals'
const MAPBOX_ACCESS_TOKEN =
  'pk.eyJ1IjoidGVjaHNldiIsImEiOiJjbG9sdjk0aDUwaWlyMmpyeGVmdmNhYWF1In0.Y0RpKW87U4BBWFIeh7dEMA'

interface JoinViewProps {
  joinRoom: any
  clientInfo: object
  mode: string
}

const Page: React.FC = (data) => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [roomCode, setRoomCode] = useState('')
  const [playerName, setPlayerName] = useState('')
  const [mode, setMode] = useState('login')
  const [channel, setChannel] = useState<PusherTypes.PresenceChannel>()
  const [clientInfo, setClientInfo] = useState({})
  const [errorMessage, setErrorMessage] = useState<string | null>(null)

  // JoinRoom

  const JoinView: React.FC<JoinViewProps> = ({ joinRoom }) => {
    const [JVRoomCode, setJVRoomCode] = useState('')
    const [JVplayerName, setJVPlayerName] = useState(
      import.meta.env.MODE === 'development' ? 'Dev' : ''
    )
    const [hideNav, setHideNav] = useState(false)
    useEffect(() => {
      const params = new URLSearchParams(window.location.search)
      const roomCode = params.get('room-code')
      const name = params.get('name')
      if (name != null) {
        setJVPlayerName(name)
      }
      if (params.get('mobile-no-nav') === 'true') {
        setHideNav(true)
      }
      if (roomCode != null && roomCode.length === 4) {
        setJVRoomCode(roomCode.toUpperCase())
      }
    }, [])

    return (
      <Flex sx={{ ...styles.container, ...styles.joinRoom }} p="20px">
        {hideNav ? (
          <style
            dangerouslySetInnerHTML={{ __html: 'header { display: none; }' }}
          />
        ) : null}
        <FormLabel>
          Name
          <FormControl sx={styles.inputWrapper}>
            <Input
              value={JVplayerName}
              placeholder="Enter your Name"
              onChange={(event) => {
                setJVPlayerName(event.target.value)
              }}
            />
            <div className="bend" />
          </FormControl>
        </FormLabel>
        <FormLabel>
          Room Code
          <FormControl sx={styles.inputWrapper} isRequired={true}>
            <Input
              value={JVRoomCode}
              placeholder="Enter 4 Character Room Code"
              autoComplete="off"
              onChange={(event) => {
                setJVRoomCode(
                  event.target.value
                    .replace(/[^a-zA-Z]/g, '')
                    .toUpperCase()
                    .slice(0, 4)
                )
              }}
            />
            <div className="bend" />
          </FormControl>
        </FormLabel>
        <Button
          isDisabled={
            JVRoomCode.length !== 4 ||
            JVplayerName === '' ||
            JVplayerName.length > 14
          }
          // colorScheme="teal"
          variant="outlineNegative"
          onClick={() => {
            joinRoom({
              roomCode: JVRoomCode,
              playerName: JVplayerName
            })
          }}
        >
          Join Room
        </Button>
      </Flex>
    )
  }

  // Fireworks views and functions
  const FireworksView: React.FC = () => {
    return (
      <Flex sx={styles.container}>
        <Button
          colorScheme="teal"
          w="80vw"
          h="auto"
          aspectRatio="1/1"
          maxW="280px"
          borderRadius="80vw"
          mx="auto"
          fontSize="72px"
          onClick={() => {
            sendFireworks()
          }}
        >
          Fire!
        </Button>
      </Flex>
    )
  }

  const sendFireworks = (): void => {
    if (channel != null) {
      channel.trigger('client-message_sent', 'send')
    }
  }

  // Video Armageddon

  const VideoArmageddonDirector: React.FC = () => {
    const [players, setPlayers] = useState<any[]>([])
    const [selectedPlayer, setSelectedPLayer] = useState<string | null>(null)
    const [powerUp, setPowerUp] = useState<string | null>(null)
    const [item, setItem] = useState<string | null>(null)
    const [effect, setEffect] = useState<string | null>(null)
    const [length, setEffectLength] = useState<number | null>(null)
    const [lives, setLives] = useState<number | null>(null)

    useEffect(() => {
      channel?.bind('client-message_sent', (message: any) => {
        triggerAction(message)
      })
    }, [])

    const triggerAction = (message: any): void => {
      switch (message.action) {
        case 'standings':
          setPlayers(message.players.split('|'))
          break
      }
    }

    const kill = (): void => {
      if (channel != null) {
        channel.trigger('client-message_sent', {
          id: channel.members.myID,
          action: 'memory',
          name: 'all',
          clientId: channel.members.me.info.name,
          memory: [['0x00b4', '0xc0', 'RAM']]
        })
      }
    }
    const sendPowerUp = (): void => {
      if (channel != null && selectedPlayer != null && powerUp != null) {
        if (powerUp === 'star') {
          channel.trigger('client-message_sent', {
            id: channel.members.myID,
            action: 'memory',
            name: selectedPlayer,
            clientId: channel.members.me.info.name,
            memory: [['0x03f2', '0x01', 'RAM']]
          })
        } else {
          channel.trigger('client-message_sent', {
            id: channel.members.myID,
            action: 'memory',
            name: selectedPlayer,
            clientId: channel.members.me.info.name,
            memory: [['0x0578', powerUp.toString(), 'RAM']]
          })
        }
      }
    }
    const sendEffect = (): void => {
      switch (effect) {
        case 'kill':
          if (channel != null && effect != null) {
            channel.trigger('client-message_sent', {
              id: channel.members.myID,
              action: effect,
              name: selectedPlayer,
              clientId: channel.members.me.info.name
            })
          }
          break
        case 'pause':
          if (channel != null && effect != null && length != null) {
            channel.trigger('client-message_sent', {
              id: channel.members.myID,
              action: effect,
              name: selectedPlayer,
              clientId: channel.members.me.info.name,
              length
            })
          }
          break
        default:
          if (channel != null && effect != null && length != null) {
            channel.trigger('client-message_sent', {
              id: channel.members.myID,
              action: effect,
              name: selectedPlayer,
              clientId: channel.members.me.info.name,
              length
            })
          }
          break
      }
    }
    const sendLives = (): void => {
      if (channel != null && lives != null) {
        channel.trigger('client-message_sent', {
          id: channel.members.myID,
          action: 'lives',
          name: selectedPlayer,
          clientId: channel.members.me.info.name,
          lives
        })
      }
    }
    const sendItem = (): void => {
      if (channel != null && item != null) {
        const uid = Date.now().toString()
        channel.trigger('client-message_sent', {
          id: channel.members.myID,
          uid,
          action: 'item',
          attacker: 'director',
          name: selectedPlayer,
          item,
          clientId: channel.members.me.info.name
        })
        channel.trigger('client-message_sent', {
          id: channel.members.myID,
          uid,
          action: 'item',
          attacker: 'director',
          name: selectedPlayer,
          item,
          clientId: channel.members.me.info.name
        })
        // channel.trigger('client-message_sent', {
        //   id: channel.members.myID,
        //   action: 'item',
        //   attacker: 'director',
        //   name: selectedPlayer,
        //   clientId: channel.members.me.info.name,
        //   item
        // })
      }
    }

    return (
      <Flex sx={styles.container}>
        <Box>
          <Heading
            fontWeight={800}
            letterSpacing={'-0.05em'}
            fontSize="21px"
            textAlign="center"
            mb="20px"
          >
            You are the director
          </Heading>
          <Box>
            <Select
              value={selectedPlayer ?? ''}
              onChange={(e) => {
                setSelectedPLayer(e.target.value)
              }}
            >
              <option value="">Select a Player</option>
              <option value="all">All Players</option>
              {players.map((player, index) => {
                return (
                  <option key={`player-${index}`} value={player}>
                    {player}
                  </option>
                )
              })}
            </Select>
            <FormLabel>
              Power Ups
              <Select
                value={powerUp ?? ''}
                onChange={(e) => {
                  setPowerUp(e.target.value)
                }}
              >
                <option value="">Select a Powerup</option>
                <option value="0x01">Small</option>
                <option value="0x02">Big</option>
                <option value="0x03">Fire</option>
                <option value="0x04">Raccoon</option>
                <option value="0x05">Frog</option>
                <option value="0x06">Tanooki</option>
                <option value="0x07">Hammer</option>
                <option value="star">Star</option>
              </Select>
            </FormLabel>
            <Button colorScheme="teal" w="100%" onClick={sendPowerUp}>
              Send Power Up
            </Button>
            <FormLabel>
              Attack
              <Select
                value={item ?? ''}
                onChange={(e) => {
                  setItem(e.target.value)
                }}
              >
                <option value="">Select an attack</option>
                <option value="banana">Banana</option>
                <option value="greenShell">greenShell</option>
                <option value="redShell">Red Shell</option>
                <option value="lightning">Lightning</option>
              </Select>
            </FormLabel>
            <Button colorScheme="teal" w="100%" onClick={sendItem}>
              Send Attack
            </Button>
            <hr />
            <FormLabel>
              Effects
              <Select
                value={effect ?? ''}
                onChange={(e) => {
                  setEffect(e.target.value)
                }}
              >
                <option value="">Select an effect</option>
                <option value="kill">Kill (instant)</option>
                <option value="pause">Freeze</option>
                <option value="slow">Slow</option>
                <option value="fast">Fast</option>
              </Select>
              <Select
                value={length ?? ''}
                onChange={(e) => {
                  setEffectLength(parseInt(e.target.value))
                }}
              >
                <option value="">Select an effect length</option>
                <option value="5">5s</option>
                <option value="10">10s</option>
                <option value="30">30s</option>
                <option value="60">60s</option>
              </Select>
            </FormLabel>
            <Button colorScheme="teal" w="100%" onClick={sendEffect}>
              Send Effect
            </Button>
            <hr />
            <FormLabel>
              Lives
              <Select
                value={lives ?? ''}
                onChange={(e) => {
                  setLives(parseInt(e.target.value))
                }}
              >
                <option value="">Select number of lives to take / give</option>
                <option value="5">5UP</option>
                <option value="1">1UP</option>
                <option value="-1">1DOWN</option>
                <option value="-5">5DOWN</option>
              </Select>
            </FormLabel>
            <Button colorScheme="teal" w="100%" onClick={sendLives}>
              Send Lives
            </Button>
          </Box>
        </Box>
      </Flex>
    )
  }

  // function searchUint8Array(array: number[], sequence: string[]): number[] {
  //   const decimalSequence = sequence.map((hex: any) => parseInt(hex, 16))
  //   const indices: number[] = []

  //   for (let i = 0; i < array.length - decimalSequence.length + 1; i++) {
  //     let match = true
  //     for (let j = 0; j < decimalSequence.length; j++) {
  //       if (array[i + j] !== decimalSequence[j]) {
  //         match = false
  //         break
  //       }
  //     }
  //     if (match) {
  //       indices.push(i)
  //     }
  //   }
  //   console.log('indices', indices)
  //   return indices // Return array of indices where the sequence is found
  // }

  // const VideoArmageddon: React.FC = () => {
  //   const emuRef = useRef<any | null>(null)
  //   const gameCanvasRef = useRef<any | null>(null)
  //   const moduleRef = useRef<any | null>(null)
  //   const prevScoreRef = useRef<number>(0)
  //   const gameTickInterval = useRef<any | null>(null)
  //   const phaseRef = useRef<string>('setup')
  //   const [phase, setPhase] = useState('setup')

  //   const testGame = (file: File): void => {
  //     const reader = new FileReader()
  //     reader.onload = function (event) {
  //       if (event.target != null) {
  //         const arrayBuffer = event.target.result
  //         const wordArray = CryptoJS.lib.WordArray.create(arrayBuffer)
  //         const hash = MD5(wordArray).toString()
  //         console.log('File hash:', hash)

  //         // Compare the hash with the expected hash
  //         const expectedHash = '86d1982fea7342c0af9679ddf3869d8d'
  //         if (hash.toLowerCase() === expectedHash.toLowerCase()) {
  //           // Load the game if the hash matches
  //           console.log('Loading game...')

  //           loadGame(file)
  //         } else {
  //           console.log('File hash does not match. Aborting...')
  //         }
  //       }
  //     }
  //     reader.readAsArrayBuffer(file)
  //   }

  //   const loadGame = (file: any): void => {
  //     Nostalgist.launch({
  //       rom: file,
  //       core: 'quicknes',
  //       element: gameCanvasRef.current,
  //       style: {
  //         width: '100%',
  //         height: '100%'
  //       }
  //     })
  //       .then((emu) => {
  //         emuRef.current = emu
  //         moduleRef.current = emu.getEmscriptenModule()
  //         clearInterval(gameTickInterval.current)
  //         gameTickInterval.current = setInterval(() => {
  //           let score = 0
  //           // let tester = []
  //           // tester = []
  //           // tester = searchUint8Array(moduleRef.current.HEAPU8, [
  //           //   '72',
  //           //   '37',
  //           //   '18',
  //           //   '73',
  //           //   '3b',
  //           //   '18'
  //           // ])
  //           // if (tester.length > 0) {
  //           //   console.log('found', tester)
  //           //   alert('found', tester[0], tester[1])
  //           //   debugger
  //           // } else {
  //           //   console.log('not found')
  //           // }
  //           switch (phaseRef.current) {
  //             case 'setup':
  //               if (
  //                 moduleRef.current.HEAPU8.at(0x00265fa0) === 0x72 &&
  //                 moduleRef.current.HEAPU8.at(0x00265fa1) === 0x37
  //               ) {
  //                 if (channel != null) {
  //                   channel.trigger('client-message_sent', {
  //                     id: channel.members.myID,
  //                     action: 'start',
  //                     clientId: channel.members.me.info.name
  //                   })
  //                   setPhase('game')
  //                   phaseRef.current = 'game'
  //                 }
  //               }

  //               break
  //             default:
  //               score = parseInt(
  //                 (moduleRef.current.HEAPU8.at(0x001fdb19)
  //                   .toString(16)
  //                   .padStart(2, '0') as string) +
  //                 (moduleRef.current.HEAPU8.at(0x001fdb1a)
  //                   .toString(16)
  //                   .padStart(2, '0') as string) +
  //                 (moduleRef.current.HEAPU8.at(0x001fdb1b)
  //                   .toString(16)
  //                   .padStart(2, '0') as string),
  //                 16
  //               )
  //               if (score !== prevScoreRef.current) {
  //                 prevScoreRef.current = score
  //                 console.log('score is ', score)
  //                 if (channel != null) {
  //                   channel.trigger('client-message_sent', {
  //                     id: channel.members.myID,
  //                     action: 'update',
  //                     clientId: channel.members.me.info.name,
  //                     score: score * 10
  //                   })
  //                 }
  //               }
  //           }
  //         }, 1000 / 60)
  //       })
  //       .catch(console.error)
  //   }

  //   return (
  //     <Flex sx={styles.container}>
  //       <Box display={phase === 'setup' ? 'block' : 'none'}>
  //         <Heading
  //           fontWeight={800}
  //           letterSpacing={'-0.05em'}
  //           fontSize="21px"
  //           textAlign="center"
  //           mb="20px"
  //         >
  //           Select your Super Mario 3 Rom
  //         </Heading>
  //         <Text textAlign="center" fontSize="18px" lineHeight={1.5}>
  //           The rom MD5 Checksum must be <br />
  //           <strong>86D1982FEA7342C0AF9679DDF3869D8D</strong>
  //           <br />
  //           otherwise the emulator will not start.
  //         </Text>
  //         <Text textAlign="center" fontSize="18px" lineHeight={1.5}>
  //           <strong>Keyboard Controls</strong>
  //           <br />
  //           Arrows Keys to move
  //           <br />
  //           Z to B / Run
  //           <br />
  //           X to A / Jump
  //           <br />
  //           Enter to start
  //           <br />
  //           Shift to select
  //           <br />
  //           F1 for more options
  //         </Text>
  //         <Text textAlign="center" fontSize="16px" lineHeight={1.5}>
  //           <em>(Controllers are supported but may need to be remapped)</em>
  //         </Text>
  //         <Box>
  //           <Input
  //             type="file"
  //             onChange={(e) => {
  //               if (e?.target?.files != null) {
  //                 testGame(e.target.files[0])
  //               }
  //             }}
  //           />
  //           {/* <Button
  //             colorScheme="teal"
  //             w="100%"
  //             onClick={async (): Promise => {
  //               await loadGame().catch(console.error)
  //             }}
  //           >
  //             Load Mario 3 Rom
  //           </Button> */}
  //         </Box>
  //       </Box>
  //       <Box
  //         ref={gameCanvasRef}
  //         id="gameCanvas"
  //         as="canvas"
  //         pos="absolute"
  //         inset="0 0 0 0"
  //       />
  //     </Flex>
  //   )
  // }

  // Start Stop Continue Section

  const StartStopContinueView = (): ReactElement => {
    const [description, setDescription] = useState<string>('')

    const sendNote = (type: string, description: string): void => {
      if (channel != null && description !== '') {
        channel.trigger('client-message_sent', {
          id: channel.members.myID,
          clientId: channel.members.me.info.name,
          type,
          description
        })
        setDescription('')
      }
    }

    return (
      <Flex sx={styles.container}>
        <FormLabel>
          What would you like to write?
          <FormControl sx={styles.inputWrapper}>
            <Input
              value={description}
              onChange={(event) => {
                setDescription(event.target.value)
              }}
            />
            <div className="bend" />
          </FormControl>
        </FormLabel>
        <Grid templateColumns="1fr 1fr 1fr" gap="16px">
          <Button
            bg="green.300"
            onClick={() => {
              sendNote('start', description)
            }}
          >
            Start
          </Button>
          <Button
            bg="red.300"
            onClick={() => {
              sendNote('stop', description)
            }}
          >
            Stop
          </Button>
          <Button
            bg="yellow.300"
            onClick={() => {
              sendNote('continue', description)
            }}
          >
            Continue
          </Button>
        </Grid>
      </Flex>
    )
  }
  // Up for discussion Section

  const UpForDiscussionView = (): ReactElement => {
    const [question, setQuestion] = useState<string>('')
    const [questionList, setQuestionList] = useState<any[]>([])

    const sendQuestion = (question: string): void => {
      if (channel != null && question !== '') {
        channel.trigger('client-message_sent', {
          id: channel.members.myID,
          clientId: channel.members.me.info.name,
          type: 'question',
          question
        })
        setQuestion('')
      }
    }
    const sendVote = (id: string, voteType: string): void => {
      if (channel != null) {
        channel.trigger('client-message_sent', {
          id: channel.members.myID,
          clientId: channel.members.me.info.name,
          type: 'vote',
          voteId: id,
          voteType
        })
        setQuestionList((prevValue) => {
          const tempQuestions = [...prevValue]
          const objWithIdIndex = tempQuestions.findIndex((obj) => obj.id === id)
          if (objWithIdIndex > -1) {
            tempQuestions[objWithIdIndex].votes = tempQuestions[
              objWithIdIndex
            ].votes.filter((e: string) => e !== playerName)
            if (voteType === 'up') {
              tempQuestions[objWithIdIndex].votes.push(playerName)
            }
          }
          return tempQuestions
        })
      }
    }

    const triggerAction = (message: any): void => {
      switch (message.action) {
        case 'updateQuestionList':
          setQuestionList(message.questions)
          break
        default:
      }
    }

    useEffect(() => {
      channel?.bind('client-message_sent', (message: any) => {
        triggerAction(message)
      })
    }, [])

    return (
      <Flex sx={styles.container}>
        <Box flexGrow="inherit" overflowY="auto">
          <Box as="ul">
            {questionList
              .filter((item) => item.archived === false)
              .map((item: any, index: number) => {
                return (
                  <Flex
                    as="li"
                    key={item.id}
                    gap="10px"
                    mb="10px"
                    alignItems="center"
                  >
                    <IconButton
                      bg={
                        item.votes.includes(playerName) === true
                          ? 'green.300'
                          : 'none'
                      }
                      border="1px solid currentcolor"
                      aria-label="Upvote this question"
                      icon={<ArrowUpIcon />}
                      onClick={() => {
                        sendVote(
                          item.id,
                          item.votes.includes(playerName) === true
                            ? 'down'
                            : 'up'
                        )
                      }}
                    />
                    <Text mb="0">{item.question}</Text>
                  </Flex>
                )
              })}
          </Box>
        </Box>
        <Box>
          <FormLabel>
            Submit Question
            <FormControl sx={styles.inputWrapper}>
              <Input
                value={question}
                onChange={(event) => {
                  setQuestion(event.target.value)
                }}
              />
              <div className="bend" />
            </FormControl>
          </FormLabel>
          <Button
            bg="green.300"
            onClick={() => {
              sendQuestion(question)
            }}
          >
            Submit Question
          </Button>
        </Box>
      </Flex>
    )
  }

  interface ClientPostItData {
    text: string
    color: string
    display?: string
    fontSize?: string
    textAlign?: string
    style?: any
    onClick?: any
  }

  const ClientPostIt: React.FC<ClientPostItData> = (props) => {
    const maxAngle = 5
    const [rotations] = useState(0 - maxAngle + Math.random() * 2 * maxAngle)
    const {
      color,
      display = '-webkit-box',
      fontSize = '',
      text,
      textAlign = 'left',
      style,
      onClick
    } = props
    const bgColors = {
      start: 'green.300',
      stop: 'red.300',
      continue: 'yellow.300'
    }[color]
    const FinalFontSize: string =
      fontSize !== ''
        ? fontSize
        : `clamp(5vw,calc(1.5vw + (40vw / ${
            text.length < 3 ? 3 : text.length
          })), 100px)`

    return (
      <Box as="button" onClick={onClick}>
        <Box
          sx={{
            bg: bgColors,
            boxShadow: '2px 2px 5px rgba(0,0,0,0.5)',
            aspectRatio: '1',
            width: '90%',
            mx: 'auto',
            mb: '10px',
            p: '20px',
            transition: 'all 500ms ease',
            transform: `rotate(${rotations}deg)`,
            pos: 'relative',
            fontFamily: 'Kalam, cursive'
          }}
          style={style}
        >
          <Box
            sx={{
              overflow: 'hidden',
              maxH: '10em',
              display,
              lineHeight: '1.25em',
              textAlign
            }}
            style={{
              fontSize: FinalFontSize
            }}
          >
            {text}
          </Box>
        </Box>
      </Box>
    )
  }

  const TwoTruthsAndALie = (): ReactElement => {
    const [submission, setSubmission] = useState<any[]>([
      {
        text: '',
        truth: true,
        votes: []
      },
      {
        text: '',
        truth: true,
        votes: []
      },
      {
        text: '',
        truth: false,
        votes: []
      }
    ])
    const [vote, setVote] = useState<number | null>(null)
    const [phase, setPhase] = useState<string>('submissions')
    const [factPhase, setFactPhase] = useState<number>(0)
    const [hideForm, setHideForm] = useState<boolean>(false)

    // const [currentVote, setCurrentVote] = useState<any | null>(null)

    const sendsubmission = (): void => {
      if (channel != null) {
        channel.trigger('client-message_sent', {
          id: channel.members.myID,
          clientId: channel.members.me.info.name,
          type: 'submission',
          submission
        })
        setPhase('waiting')
      }
    }

    const changeSubmissionText = (index: number, value: string): void => {
      setSubmission((prevValue: any[]): any => {
        prevValue[index].text = value
        return [...prevValue]
      })
    }

    const sendVote = (index: number): void => {
      if (channel != null) {
        setVote(index)
        channel.trigger('client-message_sent', {
          id: channel.members.myID,
          clientId: channel.members.me.info.name,
          type: 'vote',
          vote: index
        })
      }
    }

    const triggerAction = (message: any): void => {
      switch (message.action) {
        case 'nextVote':
          setVote(null)
          setPhase('voting')
          break
        default:
      }
    }

    const nextVotePhase = (phaseNumber: number): void => {
      setHideForm(true)
      setTimeout(() => {
        setFactPhase(phaseNumber)
        setHideForm(false)
      }, 500)
    }

    useEffect(() => {
      channel?.bind('client-message_sent', (message: any) => {
        triggerAction(message)
      })
    }, [])

    return (
      <Flex sx={styles.container}>
        {/* Fact submission */}
        <Box display={phase === 'submissions' ? 'block' : 'none'}>
          <Heading
            fontWeight={800}
            letterSpacing={'-0.05em'}
            textAlign="center"
            mb="20px"
          >
            Submit your {'"'}Facts{'"'}
          </Heading>
          <Box
            opacity={hideForm ? 0 : 1}
            display={factPhase === 0 ? 'block' : 'none'}
            transition="all 500ms ease"
          >
            <FormLabel>
              <Text textAlign="center">First Truth</Text>
              <FormControl sx={styles.inputWrapper}>
                <Input
                  value={submission[0].text}
                  onChange={(event) => {
                    changeSubmissionText(0, event.target.value)
                  }}
                />
                <div className="bend" />
              </FormControl>
            </FormLabel>
            <Button
              colorScheme="teal"
              w="100%"
              isDisabled={submission[0].text === ''}
              onClick={() => {
                nextVotePhase(1)
              }}
            >
              Next
            </Button>
          </Box>
          <Box
            opacity={hideForm ? 0 : 1}
            display={factPhase === 1 ? 'block' : 'none'}
          >
            <FormLabel>
              <Text textAlign="center">Second Truth</Text>
              <FormControl sx={styles.inputWrapper}>
                <Input
                  value={submission[1].text}
                  onChange={(event) => {
                    changeSubmissionText(1, event.target.value)
                  }}
                />
                <div className="bend" />
              </FormControl>
            </FormLabel>
            <Button
              colorScheme="teal"
              w="100%"
              isDisabled={submission[1].text === ''}
              onClick={() => {
                nextVotePhase(2)
              }}
            >
              Next
            </Button>
          </Box>
          <Box
            opacity={hideForm ? 0 : 1}
            display={factPhase === 2 ? 'block' : 'none'}
          >
            <FormLabel>
              <Text textAlign="center">Lie</Text>
              <FormControl sx={styles.inputWrapper}>
                <Input
                  value={submission[2].text}
                  onChange={(event) => {
                    changeSubmissionText(2, event.target.value)
                  }}
                />
                <div className="bend" />
              </FormControl>
            </FormLabel>
            <Button
              colorScheme="teal"
              w="100%"
              isDisabled={submission[2].text === ''}
              onClick={() => {
                sendsubmission()
              }}
            >
              Submit Question
            </Button>
          </Box>
        </Box>
        {/* End Fact submission */}

        {/* Vote */}
        <Flex flexDir="column" display={phase === 'voting' ? 'flex' : 'none'}>
          <Box w="100%">
            <Grid templateColumns={'1fr 1fr 1fr'}>
              {[0, 1, 2].map((index) => {
                return (
                  <ClientPostIt
                    key={'clientPostIt' + index.toString()}
                    text={(index + 1).toString()}
                    display="inline"
                    color={vote === index ? 'stop' : 'continue'}
                    textAlign="center"
                    onClick={() => {
                      sendVote(index)
                    }}
                  />
                )
              })}
            </Grid>
          </Box>
        </Flex>
        {/* End Vote */}

        {/* Waiting */}
        <Flex
          flexDir="column"
          display={phase === 'waiting' ? 'flex' : 'none'}
          alignItems="center"
        >
          <Box>
            <Spinner
              thickness="4px"
              speed="0.65s"
              emptyColor="gray.200"
              color="blue.500"
              size="xl"
            />
          </Box>
          <Heading
            fontWeight={800}
            letterSpacing={'-0.05em'}
            textAlign="center"
            mb="20px"
          >
            Waiting to start...
          </Heading>
        </Flex>
        {/* End Vote */}
      </Flex>
    )
  }

  // Up for discussion Section

  const VibeCheck = (): ReactElement => {
    const sendEmoji = (emoji: string): void => {
      if (channel != null && emoji !== '') {
        channel.trigger('client-message_sent', {
          id: channel.members.myID,
          clientId: channel.members.me.info.name,
          type: 'emoji',
          emoji
        })
      }
    }

    const triggerAction = (message: any): void => {}

    useEffect(() => {
      channel?.bind('client-message_sent', (message: any) => {
        triggerAction(message)
      })
    }, [])

    return (
      <Flex sx={styles.container}>
        <Box flexGrow="inherit" overflowY="auto">
          <FormLabel>
            Send Emoji
            <EmojiPicker
              onEmojiClick={(newEmoji) => {
                sendEmoji(newEmoji.emoji)
              }}
              emojiStyle={EmojiStyle.NATIVE}
              emojiVersion="5.0"
            />
          </FormLabel>
        </Box>
      </Flex>
    )
  }

  const EmojiMirror = (): ReactElement => {
    const [players, setPlayers] = useState<any[]>([])
    const [guess, setGuess] = useState<string | null>(null)
    const [phase, setPhase] = useState<string>('waiting')
    const [factPhase, setFactPhase] = useState<number>(0)
    const [hideForm, setHideForm] = useState<boolean>(false)

    // const [currentVote, setCurrentVote] = useState<any | null>(null)

    const sendGuess = (): void => {
      if (channel != null) {
        channel.trigger('client-message_sent', {
          id: channel.members.myID,
          clientId: channel.members.me.info.name,
          type: 'guess',
          guess
        })
      }
    }
    const nextResultsPhase = (phaseNumber: number): void => {
      setPhase('waiting')
    }
    const triggerAction = (message: any): void => {
      switch (message.action) {
        case 'updatePlayerList':
          setPlayers(message.players)
          setPhase('guessing')
          break
        case 'showResults':
          setPhase('results')
          break
        default:
      }
    }

    useEffect(() => {
      channel?.bind('client-message_sent', (message: any) => {
        triggerAction(message)
      })
    }, [])

    useEffect(() => {
      sendGuess()
    }, [guess])

    const currentEmoji =
      players.find((player) => {
        return player.name === playerName
      })?.emoji ?? ''

    return (
      <Flex sx={styles.container}>
        {/* Guess */}
        <Box display={phase === 'guessing' ? 'block' : 'none'}>
          <Heading
            fontWeight={800}
            letterSpacing={'-0.05em'}
            textAlign="center"
            mb="20px"
          >
            Your Emoji
          </Heading>
          <Text textAlign="center" fontSize="84px">
            {currentEmoji}
          </Text>
          <Heading
            fontWeight={800}
            letterSpacing={'-0.05em'}
            textAlign="center"
            mb="20px"
          >
            Guess your mirror
          </Heading>

          <Select
            value={guess ?? ''}
            onChange={(e) => {
              setGuess(e.target.value)
            }}
          >
            <option value="">Select a Player</option>
            {players
              .filter((player) => {
                return player.name !== playerName
              })
              .map((player, index) => {
                return (
                  <option key={`player-${index}`} value={player.name}>
                    {player.name}
                  </option>
                )
              })}
          </Select>
        </Box>
        {/* End Guess */}

        {/* Waiting */}
        <Flex
          flexDir="column"
          display={phase === 'waiting' ? 'flex' : 'none'}
          alignItems="center"
        >
          <Box>
            <Spinner
              thickness="4px"
              speed="0.65s"
              emptyColor="gray.200"
              color="blue.500"
              size="xl"
            />
          </Box>
          <Heading
            fontWeight={800}
            letterSpacing={'-0.05em'}
            textAlign="center"
            mb="20px"
          >
            Waiting to start...
          </Heading>
        </Flex>
        {/* End Waiting */}
        {/* Waiting */}
        <Flex
          flexDir="column"
          display={phase === 'results' ? 'flex' : 'none'}
          alignItems="center"
        >
          <Box>
            <Spinner
              thickness="4px"
              speed="0.65s"
              emptyColor="gray.200"
              color="blue.500"
              size="xl"
            />
          </Box>
          <Heading
            fontWeight={800}
            letterSpacing={'-0.05em'}
            textAlign="center"
            mb="20px"
          >
            Look at Screen
          </Heading>
        </Flex>
        {/* End Waiting */}
      </Flex>
    )
  }

  interface MarkerType {
    longitude: number
    latitude: number
  }

  const ZoomOut = (): ReactElement => {
    const [players, setPlayers] = useState<any[]>([])
    const mapRef = useRef(null)
    const [mapLoaded, setMapLoaded] = useState(false)
    const [marker, setMarker] = useState<MarkerType | null>(null)
    const [phase, setPhase] = useState<string>('guessing')
    const [factPhase, setFactPhase] = useState<number>(0)
    const [hideForm, setHideForm] = useState<boolean>(false)

    // const [currentVote, setCurrentVote] = useState<any | null>(null)

    const handleMapClick = (event: any): void => {
      const longitude = event.lngLat.lng
      const latitude = event.lngLat.lat

      // Create a new marker object with the clicked coordinates
      const newMarker: MarkerType = {
        longitude,
        latitude
      }

      // Set the marker state
      setMarker(newMarker)

      // You can now use latitude and longitude as needed (e.g., for an API call, etc.)
      console.log('Clicked at:', { latitude, longitude })
    }

    const sendGuess = (): void => {
      if (channel != null) {
        channel.trigger('client-message_sent', {
          id: channel.members.myID,
          clientId: channel.members.me.info.name,
          type: 'guess',
          guess: marker
        })
        // setPhase('waiting')
      }
    }

    const triggerAction = (message: any): void => {
      switch (message.action) {
        case 'updatePlayerList':
          setPlayers(message.players)
          setPhase('guessing')
          break
        case 'showResults':
          setPhase('results')
          break
        default:
      }
    }

    useEffect(() => {
      channel?.bind('client-message_sent', (message: any) => {
        triggerAction(message)
      })
    }, [])

    return (
      <Flex sx={styles.container}>
        {/* Guess */}
        <Box
          pos="relative"
          h="100%"
          display={phase === 'guessing' ? 'block' : 'none'}
        >
          <Map
            onLoad={() => {
              setMapLoaded(true)
            }}
            style={{ position: 'absolute', inset: 0 }}
            ref={mapRef}
            mapboxAccessToken={MAPBOX_ACCESS_TOKEN}
            mapStyle="mapbox://styles/mapbox/streets-v12"
            onClick={handleMapClick}
          >
            {/* Display the marker if it exists */}
            {marker != null && (
              <Marker longitude={marker.longitude} latitude={marker.latitude} />
            )}
          </Map>
          <Button
            pos="absolute"
            inset="auto 30px 30px"
            colorScheme="teal"
            isDisabled={marker === null}
            onClick={() => {
              sendGuess()
            }}
            zIndex="10"
          >
            Send Guess
          </Button>
        </Box>
        {/* End Guess */}

        {/* Waiting */}
        <Flex
          flexDir="column"
          display={phase === 'waiting' ? 'flex' : 'none'}
          alignItems="center"
        >
          <Box>
            <Spinner
              thickness="4px"
              speed="0.65s"
              emptyColor="gray.200"
              color="blue.500"
              size="xl"
            />
          </Box>
          <Heading
            fontWeight={800}
            letterSpacing={'-0.05em'}
            textAlign="center"
            mb="20px"
          >
            Waiting to start...
          </Heading>
        </Flex>
        {/* End Waiting */}
        {/* Waiting */}
        <Flex
          flexDir="column"
          display={phase === 'results' ? 'flex' : 'none'}
          alignItems="center"
        >
          <Box>
            <Spinner
              thickness="4px"
              speed="0.65s"
              emptyColor="gray.200"
              color="blue.500"
              size="xl"
            />
          </Box>
          <Heading
            fontWeight={800}
            letterSpacing={'-0.05em'}
            textAlign="center"
            mb="20px"
          >
            Look at Screen
          </Heading>
        </Flex>
        {/* End Waiting */}
      </Flex>
    )
  }

  const Impaintient = (): ReactElement => {
    const [phase, setPhase] = useState<string>('waiting')
    const [guess, setGuess] = useState<string>('')
    const [tries, setTries] = useState<number>(2)
    const [correctGuess, setCorrectGuess] = useState<string | null>(null)
    const sendGuess = (): void => {
      if (channel != null) {
        channel.trigger('client-message_sent', {
          id: channel.members.myID,
          clientId: channel.members.me.info.name,
          type: 'guess',
          guess
        })
        setPhase('waiting')
      }
    }

    const triggerAction = (message: any): void => {
      switch (message.action) {
        case 'currentRound':
          setCorrectGuess(atob(message.data.word))
          setPhase('guessing')
          break
        case 'nextRound':
          setGuess('')
          setCorrectGuess(atob(message.data.word))
          setTries(2)
          setPhase('guessing')
          break
        case 'showResults':
          setPhase('results')
          break
        default:
      }
    }

    useEffect(() => {
      if (guess.toLowerCase() === correctGuess?.toLowerCase()) {
        sendGuess()
      }
    }, [guess])

    useEffect(() => {
      if (tries === 0) {
        setPhase('waiting')
      }
    }, [tries])

    useEffect(() => {
      channel?.bind('client-message_sent', (message: any) => {
        triggerAction(message)
      })
    }, [])

    return (
      <Flex sx={styles.container}>
        {/* Guess */}
        <Flex
          pos="relative"
          alignItems="center"
          flexDir="column"
          justifyContent="center"
          h="100%"
          display={phase === 'guessing' ? 'flex' : 'none'}
        >
          <FormControl isInvalid={tries < 2} sx={styles.inputWrapper}>
            <FormLabel>
              <Text textAlign="center"></Text>
              <Heading
                fontWeight={800}
                letterSpacing={'-0.05em'}
                textAlign="center"
                mb="0px"
              >
                Guess The Item <br />
                On Screen
              </Heading>
              <Text textAlign="center" fontSize="14px">
                You Only Get 2 Tries
              </Text>
              {correctGuess !== null && (
                <Box pos="relative">
                  <Input
                    value={guess ?? ''}
                    placeholder="Type One Letter at a Time"
                    disabled={tries === 0}
                    onChange={(event) => {
                      let correct = true
                      for (let i = 0; i < event.target.value.length; i++) {
                        if (
                          correctGuess !== null &&
                          event.target.value[i].toLowerCase() !==
                            correctGuess[i].toLowerCase()
                        ) {
                          correct = false
                          break
                        }
                      }
                      if (correct) {
                        setGuess(event.target.value)
                      } else {
                        setTries((prevValue) => {
                          return prevValue - 1
                        })
                      }
                    }}
                  />
                  <div className="bend" />
                </Box>
              )}
            </FormLabel>
            {tries === 1 && (
              <FormErrorMessage>Wrong Letter, Last Chance</FormErrorMessage>
            )}
            {tries === 0 && <FormErrorMessage>Wrong</FormErrorMessage>}
            {correctGuess !== null && guess === correctGuess && (
              <FormHelperText>Correct Answer</FormHelperText>
            )}
          </FormControl>
          {/* <Button
            pos="absolute"
            inset="auto 30px 30px"
            colorScheme="teal"
            isDisabled={guess === '' || tries === 0}
            onClick={() => {
              sendGuess()
            }}
            zIndex="10"
          >
            Send Guess
          </Button> */}
        </Flex>
        {/* End Guess */}

        {/* Waiting */}
        <Flex
          flexDir="column"
          display={phase === 'waiting' ? 'flex' : 'none'}
          alignItems="center"
        >
          <Heading
            fontWeight={800}
            letterSpacing={'-0.05em'}
            textAlign="center"
            mb="20px"
          >
            {tries === 0 && 'Wrong'}
            {tries > 0 && guess !== '' && 'Correct Answer'}
          </Heading>
          <Box>
            <Spinner
              thickness="4px"
              speed="0.65s"
              emptyColor="gray.200"
              color="blue.500"
              size="xl"
            />
          </Box>
          <Heading
            fontWeight={800}
            letterSpacing={'-0.05em'}
            textAlign="center"
            mb="20px"
          >
            Waiting for next round...
          </Heading>
        </Flex>
        {/* End Waiting */}
        {/* Waiting */}
        <Flex
          flexDir="column"
          display={phase === 'results' ? 'flex' : 'none'}
          alignItems="center"
        >
          <Box>
            <Spinner
              thickness="4px"
              speed="0.65s"
              emptyColor="gray.200"
              color="blue.500"
              size="xl"
            />
          </Box>
          <Heading
            fontWeight={800}
            letterSpacing={'-0.05em'}
            textAlign="center"
            mb="20px"
          >
            Look at Screen
          </Heading>
        </Flex>
        {/* End Waiting */}
      </Flex>
    )
  }

  enum PlayerState {
    SETUP,
    WAITING,
    DRAWING,
    GUESSING
  }

  const pieces = ['💀', '👠', '📯', '🧸', '🍦']

  const Quietro = (): ReactElement => {
    const [phase, setPhase] = useState<PlayerState>(PlayerState.WAITING)
    const [maxBots, setMaxBots] = useState<number>(0)
    const [difficulty, setDifficulty] = useState<number>(0)
    const [guess, setGuess] = useState<string>('')
    const [correctLetters, setCorrectLetters] = useState<string>('')
    const [tries, setTries] = useState<number>(2)
    const [playerNumber, setPlayerNumber] = useState<number>(0)
    const guessInputRef = useRef<HTMLInputElement>(null)

    const startGame = (): void => {
      if (channel != null) {
        channel.trigger('client-message_sent', {
          id: channel.members.myID,
          clientId: channel.members.me.info.name,
          action: 'start',
          maxBots,
          difficulty
        })
        setPhase(PlayerState.WAITING)
      }
    }

    const sendGuess = (): void => {
      if (channel != null) {
        channel.trigger('client-message_sent', {
          id: channel.members.myID,
          clientId: channel.members.me.info.name,
          action: 'guess',
          guess
        })
        setPhase(PlayerState.WAITING)
      }
    }

    const sendBuzzer = (): void => {
      if (channel != null) {
        channel.trigger('client-message_sent', {
          id: channel.members.myID,
          clientId: channel.members.me.info.name,
          action: 'buzz'
        })
        // setPhase(PlayerState.WAITING)
      }
    }

    const triggerAction = (message: any): void => {
      let playerIndex: number
      switch (message.action) {
        case 'players':
          playerIndex = message.players.findIndex(
            (player: { clientId: any }) => {
              return player.clientId === channel?.members.me.info.name
            }
          )
          if (playerIndex === -1) {
            return
          }

          setPlayerNumber(playerIndex + 1)
          if (playerIndex === 0) {
            setPhase(PlayerState.SETUP)
          }
          break
        case 'phase':
          if (message.phase === 'DRAWING') {
            setGuess('')
            setCorrectLetters('')
          }
          setPhase(PlayerState[message.phase] as unknown as PlayerState)
          break

        case 'buzzed_in':
          if (message.buzzedIn === channel?.members.me.info.name) {
            setGuess('')
            setCorrectLetters('')
            setPhase(PlayerState.GUESSING)
            guessInputRef.current?.focus()
          } else {
            setPhase(PlayerState.WAITING)
          }
          break

        case 'reset_tries':
          setTries(2)
          break

        case 'wrong_guess':
          if (message.buzzedIn === channel?.members.me.info.name) {
            setTries((prevValue) => {
              return prevValue - 1
            })
            setGuess('')

            if (tries === 2) {
              setCorrectLetters(message.correctLetters)
              setPhase(PlayerState.GUESSING)
            } else {
              setPhase(PlayerState.WAITING)
            }
          }
          break
        case 'short_guess':
          if (message.buzzedIn === channel?.members.me.info.name) {
            setCorrectLetters(message.correctLetters)
            setGuess('')
            setPhase(PlayerState.GUESSING)
          }
          break
        default:
      }
    }

    useEffect(() => {
      channel?.bind('client-message_sent', (message: any) => {
        triggerAction(message)
      })
    }, [])

    return (
      <Flex sx={styles.container}>
        {/* Waiting */}
        <Flex
          flexDir="column"
          display={phase === PlayerState.SETUP ? 'flex' : 'none'}
          alignItems="center"
        >
          <Heading
            fontWeight={800}
            letterSpacing={'-0.05em'}
            textAlign="center"
            mb="20px"
          >
            Player 1, Please select the game options
          </Heading>
          <FormLabel w="100%">
            Max Number of Computer Players
            <Select
              w="100%"
              value={maxBots}
              onChange={(event) => {
                setMaxBots(parseInt(event.target.value))
              }}
            >
              <option value="0">0</option>
              <option value="1">1</option>
              <option value="2">2</option>
              <option value="3">3</option>
            </Select>
          </FormLabel>
          <FormLabel w="100%">
            Select Skill Level
            <Select
              w="100%"
              value={difficulty}
              onChange={(event) => {
                setDifficulty(parseInt(event.target.value))
              }}
            >
              <option value="0">Easy</option>
              <option value="1">Medium</option>
              <option value="2">Hard</option>
              <option value="3">Very Hard</option>
            </Select>
          </FormLabel>
          <Button
            colorScheme="teal"
            onClick={() => {
              startGame()
            }}
            zIndex="10"
          >
            Start Game
          </Button>
        </Flex>
        {/* End Waiting */}

        {/* Waiting */}
        <Flex
          flexDir="column"
          display={phase === PlayerState.WAITING ? 'flex' : 'none'}
          alignItems="center"
        >
          <Box>
            <Spinner
              thickness="4px"
              speed="0.65s"
              emptyColor="gray.200"
              color="blue.500"
              size="xl"
            />
          </Box>
          <Heading
            fontWeight={800}
            letterSpacing={'-0.05em'}
            textAlign="center"
            mb="20px"
          >
            {playerNumber > 0 && (
              <>
                You are Player {playerNumber} {pieces[playerNumber]}{' '}
              </>
            )}
            <br />
            Look at the screen
          </Heading>
        </Flex>
        {/* End Waiting */}

        {/* Drawing */}

        <Flex
          flexDir="column"
          display={phase === PlayerState.DRAWING ? 'flex' : 'none'}
          alignItems="center"
        >
          <Heading
            fontWeight={800}
            letterSpacing={'-0.05em'}
            textAlign="center"
            mb="20px"
          >
            You are Player {playerNumber} {pieces[playerNumber]}
            <br />
            {tries === 2 && <> Buzz in if you Know The Word </>}
            {tries === 0 && <> Out of Guesses </>}
          </Heading>
          <Button
            display={tries === 2 ? 'block' : 'none'}
            w="50%"
            h="auto"
            aspectRatio={1}
            borderRadius="100%"
            colorScheme="red"
            border="3px solid black"
            boxShadow={'2px 2px 5px rgba(0,0,0,0.5)'}
            onClick={() => {
              sendBuzzer()
            }}
          ></Button>
        </Flex>

        {/* End Drawing */}

        {/* Guessing */}
        <Flex
          pos="relative"
          alignItems="center"
          flexDir="column"
          justifyContent="center"
          h="100%"
          display={phase === PlayerState.GUESSING ? 'flex' : 'none'}
        >
          <FormControl sx={styles.inputWrapper}>
            <FormLabel>
              <Text textAlign="center"></Text>
              <Heading
                fontWeight={800}
                letterSpacing={'-0.05em'}
                textAlign="center"
                mb="0px"
              >
                Guess The Item On Screen
                <br />
                {tries === 2 && 'You Have 2 Tries'}
                {tries < 2 && 'Last Chance'}
              </Heading>

              <Box pos="relative">
                <Input
                  ref={guessInputRef}
                  isInvalid={guess.length === 0}
                  value={correctLetters + guess}
                  onKeyUp={(event) => {
                    if (event.key === 'Enter') {
                      sendGuess()
                    }
                  }}
                  onChange={(event) => {
                    setGuess(
                      event.target.value
                        .slice(correctLetters.length)
                        .replace(/[^a-zA-Z\s]/g, '')
                        .toUpperCase()
                    )
                  }}
                />
                <div className="bend" />
              </Box>
            </FormLabel>
            {tries === 1 && <FormErrorMessage>Last Chance</FormErrorMessage>}
          </FormControl>
          <Button
            w="100%"
            colorScheme="teal"
            isDisabled={guess === ''}
            onClick={() => {
              sendGuess()
            }}
            zIndex="10"
          >
            Send Guess
          </Button>
        </Flex>
        {/* End Guess */}
      </Flex>
    )
  }

  const joinRoom = (newClientInfo: {
    playerName: string
    roomCode: string
  }): void => {
    if (profanity.exists(newClientInfo.playerName)) {
      setErrorMessage(
        `Really? "${newClientInfo.playerName}" is your name? Let's try that again. `
      )
      return
    }
    setPlayerName(newClientInfo.playerName)
    setRoomCode(newClientInfo.roomCode)

    const client = new PusherJS(import.meta.env.PUBLIC_ENV__SOKETI_KEY, {
      wsHost: 'reactvts.com',
      wssPort: 6001,
      forceTLS: true,
      cluster: 'soketi',
      userAuthentication: {
        endpoint: 'https://reactvts.com:3030/pusher/user-auth',
        transport: 'ajax'
      },
      channelAuthorization: {
        endpoint: 'https://reactvts.com:3030/pusher/auth',
        transport: 'ajax',
        params: {
          userType: 'client',
          name: newClientInfo.playerName
        }
      },
      disableStats: true,
      enabledTransports: ['ws', 'wss']
    })

    const tempChannel: any = client.subscribe(
      'presence-' +
        newClientInfo.roomCode +
        (newClientInfo.playerName === 'director' ? '-game' : '')
    )

    tempChannel.bind('pusher:subscription_succeeded', function () {
      if (
        !Object.keys(tempChannel.members.members).some((member) =>
          member.includes('room-')
        )
      ) {
        client.unsubscribe('presence-' + newClientInfo.roomCode)
        setErrorMessage('Room Code is incorrect or the room no longer exists.')
      } else if (
        Object.keys(tempChannel.members.members).filter(
          (member) =>
            tempChannel.members.members[member].name.toLowerCase() ===
            newClientInfo.playerName.toLowerCase()
        ).length > 1
      ) {
        client.unsubscribe('presence-' + newClientInfo.roomCode)
        setErrorMessage(
          'This name is already in use, please try different name.'
        )
      } else {
        tempChannel.bind('client-message_full', function (message: any) {
          if (message.clientId === newClientInfo.playerName) {
            setErrorMessage('Room is full, please try again later.')
            client.unsubscribe('presence-' + newClientInfo.roomCode)
            setMode('login')
          }
        })
        setChannel(tempChannel)
        const memberServerKey = Object.keys(tempChannel.members.members).find(
          (name) => {
            return name.includes('room-')
          }
        )
        if (typeof memberServerKey !== 'undefined') {
          switch (tempChannel.members.members[memberServerKey].name) {
            // case 'server-va':
            //   setMode('videoArmageddon')
            // break
            case 'server-fireworks':
              setMode('fireworks')
              break
            case 'server-ssc':
              setMode('startStopContinue')
              break
            case 'server-ufd':
              setMode('upForDiscussion')
              break
            case 'server-ttaal':
              setMode('twoTruthsAndALie')
              break
            case 'server-vc':
              setMode('vibeCheck')
              break
            case 'server-em':
              setMode('emojiMirror')
              break
            case 'server-zo':
              setMode('zoomOut')
              break
            case 'server-ip':
              setMode('impaintient')
              break
            case 'server-qi':
              setMode('quietro')
              break
            case 'server-pa':
            case 'server-pal':
              setMode('playAlong')
              break
            default:
          }
        }
        setClientInfo(newClientInfo)
      }
    })
  }
  if (channel === undefined) {
    return (
      <>
        <JoinView mode={mode} clientInfo={clientInfo} joinRoom={joinRoom} />
        <ErrorModal
          isOpen={errorMessage !== null}
          onClose={() => {
            setErrorMessage(null)
          }}
        >
          {errorMessage}
        </ErrorModal>
      </>
    )
  }

  switch (mode) {
    case 'login':
      return (
        <>
          <JoinView mode={mode} clientInfo={clientInfo} joinRoom={joinRoom} />
          <ErrorModal
            isOpen={errorMessage !== null}
            onClose={() => {
              setErrorMessage(null)
            }}
          >
            {errorMessage}
          </ErrorModal>
        </>
      )
    case 'fireworks':
      return <FireworksView />
    case 'startStopContinue':
      return <StartStopContinueView />
    case 'twoTruthsAndALie':
      return <TwoTruthsAndALie />
    case 'upForDiscussion':
      return <UpForDiscussionView />
    case 'vibeCheck':
      return <VibeCheck />
    case 'emojiMirror':
      return <EmojiMirror />
    case 'zoomOut':
      return <ZoomOut />
    case 'impaintient':
      return <Impaintient />
    case 'playAlong':
      return <PlayAlong channel={channel} playerName={playerName} />
    case 'quietro':
      return <Quietro />
    case 'videoArmageddon':
      if (playerName === 'director') {
        return <VideoArmageddonDirector />
      }
      // else {
      //   return <VideoArmageddon />
      // }
      break

    default:
  }
}

export const styles = {
  container: {
    maxW: { base: 'calc(100%)', md: '500px' },
    p: '20px',
    mx: { base: 'auto', md: 'auto' },
    flex: 1,
    backgroundColor: '#fff',
    justifyContent: 'center',
    flexDir: 'column',
    height: 'calc(100dvh - 59px)',
    maxHeight: '-webkit-fill-available',
    label: {
      mr: '0',
      mb: '12px',
      fontSize: '18px',
      fontWeight: 'bold'
    }
  },
  joinRoom: {
    input: {
      // textTransform: 'uppercase'
    }
  },
  inputWrapper: {
    input: {
      fontSize: '18px',
      fontWeight: '700',
      border: '2px solid',
      borderRadius: 0,
      borderColor: 'yellow.400',
      background: 'yellow.200',
      pr: '40px'
    },
    '.bend': {
      position: 'absolute',
      bg: 'white',
      bottom: '0px',
      right: '0px',
      borderStyle: 'solid',
      h: 'auto',
      aspectRatio: '1/1',
      w: '5%',
      boxShadow: '0px 2px 0px 0px white, 2px 0px 0px 0px white',
      transition: 'all 0.5s',
      zIndex: 2,
      overflow: 'hidden',
      '&:after': {
        pointerEvents: 'none',
        color: 'yellow.100',
        background:
          'linear-gradient(135deg, currentcolor calc(50% - 1px), rgba(232,232,232,1) 50%, rgba(255,255,255,0) 50.2%, rgba(255,255,255,0) 100%)',
        content: '""',
        display: 'block',
        pos: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0
      },
      button: {
        pos: 'absolute',
        right: '20px',
        bottom: '20px'
      }
    },
    '&:hover': {
      transitionDelay: '.1s',
      borderColor: 'yellow.400'
    },
    '&:hover .bend': {
      w: '8%'
    }
  }
}

export { Page }
